import camelCase from 'lodash/fp/camelCase';
import compose from 'lodash/fp/compose';
import curry from 'lodash/fp/curry';
import head from 'lodash/fp/head';
import mapKeys from 'lodash/fp/mapKeys';
import mapValues from 'lodash/fp/mapValues';
import mergeWith from 'lodash/fp/mergeWith';
import uniqBy from 'lodash/fp/uniqBy';
import isObject from 'lodash/isObject';

/**
 * Enumerate over an object, and return an array of mapped values generated by
 * running fn on each property value.
 * @param  {object}   obj  Object to map over
 * @param  {Function} fn   callback function to operate
 * @return {array}
 */
export const mapToValues = curry((fn, obj) =>
  Object.keys(obj).reduce(
    (acc, item) => acc.concat(fn(obj[item], item)),
    [],
  ),
);

export const mergeEntitiesWithConcat = mergeWith((value, src) => (
  Array.isArray(value) ? uniqBy('id', value.concat(src)) : undefined
));

/**
 * Recursively map keys within a nested object of objects or object of collections to camelCase.
 * @param {object} value
 * @return {object}
 */
export function camelCaseKeysDeep(value) {
  return compose(mapKeys(camelCase), mapValues(camelCaseValue))(value);
}

function camelCaseValue(value) {
  if (isCollection(value)) {
    return value.map(camelCaseKeysDeep);
  }
  if (Array.isArray(value) || 'function' === typeof value) {
    return value;
  }
  if (isObject(value)) {
    return camelCaseKeysDeep(value);
  }

  return value;
}

function isCollection(value) {
  return Array.isArray(value) && isObject(head(value));
}
